<template>
    <div>
        <div class="smallContent">
            <div class="seriesContainer">
                <router-link v-for="element in seriesElements"
                    :to="{ name: 'seriesDetail', params: { slug: element.slug } }" class="seriesElement">
                    <div class="elementContent">
                        <div class="elementText">
                            <div>{{ element.title }}</div>
                            <div>{{ getSeriesDate(element.earliest_item, element.latest_item) }}</div>
                        </div>
                        <div class="elementImage">
                            <img :src="element.thumbnail">
                        </div>

                    </div>
                </router-link>
            </div>
        </div>

        <Footer></Footer>
    </div>
</template>

<script>
import { store } from "../store";
import axios from "axios";
import Footer from "./Footer.vue";
import { getSeriesDate } from "../composables/date.js"


export default {
    name: "SeriesList",
    components: {
        Footer,
    },
    data() {
        return {
            store: store,
            seriesElements: [],
            getSeriesDate: getSeriesDate
        };
    },
    methods: {
    },
    mounted: function () {
        let myself = this;
        axios.get("/api/series-list").then((response) => {
            this.seriesElements = response.data.series;
        });
        //axios
        //.get('/api/get-streams')
        //.then(response => {
        //this.streams = response.data.items;
        //})
    },
};
</script>
<style scoped>
.seriesContainer {

    /* --gap: 2px; */
    /* --line-offset: calc(var(--gap) / 2); */
    /* --line-thickness: 1px; */
    /* --line-color: black; */

    display: grid;
    grid-template-columns: repeat(auto-fill, minmax(min(450px, 100%), 1fr));
    overflow: hidden;
    /* gap: var(--gap); */
    transform: translateX(1px);
}

.seriesElement {
    /* position: relative; */
    border-bottom: 1px solid black;
    border-right: 1px solid black;
}

/* .seriesElement::before, */
/* .seriesElement::after { */
/*     content: ''; */
/*     position: absolute; */
/*     background-color: var(--line-color); */
/*     z-index: 1; */
/* } */

/* .seriesElement::after { */
/*     inline-size: 100vw; */
/*     block-size: var(--line-thickness); */
/*     inset-inline-start: 0; */
/*     inset-block-start: calc(var(--line-offset) * -1); */
/* } */

/* .seriesElement::before { */
/*     inline-size: var(--line-thickness); */
/*     block-size: 100vh; */
/*     inset-inline-start: calc(var(--line-offset) * -1); */
/* } */

.elementContent {
    padding: 1rem;
}

.elementImage {
    padding: 3rem;
    max-width: 100%;
    box-sizing: border-box;
    aspect-ratio: 1 / 1;
    max-height: 100%;

}

.elementImage>img {
    width: 100%;
    object-fit: cover;
}
</style>
